import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { PropertySearchWidgetLocation } from '@app/modules/direct/services/direct.service';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay, tap } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-edit-location',
  templateUrl: './dialog-edit-location.component.html',
  styleUrls: ['./dialog-edit-location.component.scss'],
})
export class DialogEditLocationComponent implements OnInit {
  apiLoaded: Observable<boolean>;
  markers: any[] = [];

  latitude: number;
  longitude: number;

  @ViewChild('mapSearchField') mapSearchField: ElementRef;
  @ViewChild(GoogleMap) map: GoogleMap;

  constructor(
    private httpClient: HttpClient,
    public dialogRef: MatDialogRef<DialogEditLocationComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: { mode: 'create' | 'update'; location: PropertySearchWidgetLocation }
  ) { }

  ngOnInit(): void {
    this.dialogRef.backdropClick().subscribe((_) => {
      // You can use the same close method to pass back data
      this.dialogRef.close(this.dialogData.location);
    });

    if (this.dialogData.mode === 'update') {
      this.markers.push({
        position: {
          lat: +this.dialogData.location.lat,
          lng: +this.dialogData.location.lng,
        },
        options: {
          draggable: false,
          title: this.dialogData.location.name,
        },
      });
    }

    if (!(window.google && window.google.maps)) {
      this.apiLoaded = this.httpClient
        .jsonp(
          'https://maps.googleapis.com/maps/api/js?key=AIzaSyBBhVlQ_rfVVB8NwRS4-RPj_Yp5w4gd7lQ&libraries=places',
          'callback'
        )
        .pipe(
          tap(() => {
            setTimeout(() => {
              this.initMapSearch();
            }, 100);
          }),
          map(() => true),
          catchError((err) => {
            console.log('error loading map', err);
            return of(false);
          }),
          shareReplay(1)
        );
    } else {
      this.apiLoaded = of(true).pipe(
        tap(() => setTimeout(() => this.initMapSearch(), 1000)),
        shareReplay(1)
      );
    }
  }

  initMapSearch() {
    const searchBox = new google.maps.places.SearchBox(this.mapSearchField.nativeElement);
    this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(this.mapSearchField.nativeElement);

    searchBox.addListener('places_changed', () => {
      const places = searchBox.getPlaces();

      if (places.length === 0) {
        return;
      }

      const bounds = new google.maps.LatLngBounds();

      places.forEach((place) => {
        if (!place.geometry || !place.geometry.location) {
          return;
        }

        if (place.geometry.viewport) {
          bounds.union(place.geometry.viewport);
        } else {
          bounds.extend(place.geometry.location);
        }
      });

      this.map.fitBounds(bounds);

      this.onMapClick({ latLng: places[0].geometry.location } as google.maps.MapMouseEvent);
      this.dialogData.location.name = places[0].name;
    });
  }

  onMapClick(event: google.maps.MapMouseEvent) {
    // Clear the previous markers
    this.markers = [];

    // Get the coordinates from the event
    const coords = event.latLng.toJSON();

    // Update the component properties
    this.dialogData.location.lat = '' + coords.lat;
    this.dialogData.location.lng = '' + coords.lng;

    // Add a new marker to the markers array
    this.markers.push({
      position: coords,
      options: {
        draggable: false, // Set to true if you want the marker to be draggable
        title: this.dialogData.location.name,
      },
    });
  }
}
